import { Component, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { BannerConfig } from '../../../environments/environment.interface';

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './environment-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./environment-banner.component.scss'],
})
export class EnvironmentBannerComponent {
  private readonly storageKey = 'vortex-banner-dismissed';
  
  // Banner configuration from environment
  readonly config: BannerConfig | undefined = environment.banner;
  
  // Track dismissal state in a signal
  readonly isDismissed = signal<boolean>(false);
  
  // Computed: show banner if enabled, config exists, and not dismissed
  readonly showBanner = computed(() => {
    const config = this.config;
    return config?.enabled && !this.isDismissed();
  });

  constructor() {
    // Load dismissal state from localStorage on init
    this.loadDismissalState();
  }

  private loadDismissalState(): void {
    if (typeof localStorage === 'undefined') {
      return;
    }

    try {
      const dismissed = localStorage.getItem(this.storageKey);
      if (dismissed === 'true') {
        this.isDismissed.set(true);
      }
    } catch (error) {
      console.warn('Failed to load banner dismissal state:', error);
    }
  }

  dismiss(): void {
    this.isDismissed.set(true);
    
    // Persist dismissal to localStorage
    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem(this.storageKey, 'true');
      } catch (error) {
        console.warn('Failed to save banner dismissal state:', error);
      }
    }
  }
}
